// Section 9 Options Definitions
// These will eventually come from an admin panel/API

export const HALLGATOI_LETSZAMTREND_OPTIONS = {
    hu: [
        { value: 'jn', label: 'Jelentősen növekvő (>20%)' },
        { value: 'mn', label: 'Mérsékelten növekvő (10-20%)' },
        { value: 'stabil', label: 'Stabil (+/- 10%)' },
        { value: 'ecs', label: 'Enyhén csökkenő (10-20%)' },
        { value: 'jcs', label: 'Jelentősen csökkenő (>20%)' }
    ],
    en: [
        { value: 'jn', label: 'Significantly increasing  (>20%)' },
        { value: 'mn', label: 'Moderately increasing  (10–20%)' },
        { value: 'stabil', label: 'Stable  (±10%)' },
        { value: 'ecs', label: 'Slightly decreasing  (10–20%)' },
        { value: 'jcs', label: 'Significantly decreasing  (>20%)' }
    ]
};

export const ELOREHALADASI_ARANY_OPTIONS = {
    hu: [
        { value: 'kiemelkedo', label: 'Kiemelkedő' },
        { value: 'megfelelo', label: 'Megfelelő' },
        { value: 'fejlesztendo', label: 'Fejlesztendő' },
        { value: 'kritikus', label: 'Kritikus' }
    ],
    en: [
        { value: 'kiemelkedo', label: 'Excellent' },
        { value: 'megfelelo', label: 'Adequate' },
        { value: 'fejlesztendo', label: 'Requires development' },
        { value: 'kritikus', label: 'Critical' }
    ]
};

export const PROBLEMAS_TANTARGYAK_ELOFORDULASA_OPTIONS = {
    hu: [
        { value: 'nincs_problemas', label: 'Nincs problémás tantárgy' },
        { value: 'egy_ket_erintett', label: '1–2 tantárgy érintett' },
        { value: 'tobb_erintett', label: 'Több tantárgy érintett' },
        { value: 'kritikus_mennyisegu', label: 'Kritikus mennyiségű tantárgy' }
    ],
    en: [
        { value: 'nincs_problemas', label: 'No problematic courses' },
        { value: 'egy_ket_erintett', label: '1–2 courses affected' },
        { value: 'tobb_erintett', label: 'Multiple courses affected' },
        { value: 'kritikus_mennyisegu', label: 'Critical number of courses affected' }
    ]
};

export const PROBLEMAK_JELLEGE_OPTIONS = {
    hu: [
        { value: 'magas_bukasi', label: 'Magas bukási arány' },
        { value: 'alacsony_othv', label: 'Alacsony OTHV érték' },
        { value: 'szoveges_panasz', label: 'Szöveges hallgatói panaszok' },
        { value: 'oktato_onreflexio', label: 'Oktató önreflexiós jelzése' },
        { value: 'tananyag_problema', label: 'Tananyag-probléma' },
        { value: 'szervezesi_problema', label: 'Szervezési vagy vizsgáztatási probléma' }
    ],
    en: [
        { value: 'magas_bukasi', label: 'High failure rate' },
        { value: 'alacsony_othv', label: 'Low Student Evaluation of Teaching Performance (SETP) score' },
        { value: 'szoveges_panasz', label: 'Written student complaints' },
        { value: 'oktato_onreflexio', label: 'Teaching staff self-reflective feedback' },
        { value: 'tananyag_problema', label: 'Teaching material-related issues' },
        { value: 'szervezesi_problema', label: 'Organizational or examination-related issues' }
    ]
};

export const TELJESITMENY_ERTEKELES_OPTIONS = {
    hu: [
        { value: 'kivalo', label: 'Kiváló (átlag KI >3,5)' },
        { value: 'jo', label: 'Jó (átlag KI 3,0-3,5)' },
        { value: 'megfelelo', label: 'Megfelelő (átlag KI 2,5-3,0)' },
        { value: 'gyenge', label: 'Gyenge (átlag KI 2,0-2,5)' },
        { value: 'kritikus', label: 'Kritikus (átlag KI <2,0)' }
    ],
    en: [
        { value: 'kivalo', label: 'Excellent (avg. KI >3.5)' },
        { value: 'jo', label: 'Good (avg. KI 3.0-3.5)' },
        { value: 'megfelelo', label: 'Adequate (avg. KI 2.5-3.0)' },
        { value: 'gyenge', label: 'Weak (avg. KI 2.0-2.5)' },
        { value: 'kritikus', label: 'Critical (avg. KI <2.0)' }
    ]
};

export const JELENTKEZESI_TREND_OPTIONS = {
    hu: [
        { value: 'jelentosen_novekvo', label: 'Jelentősen növekvő érdeklődés (>20%)' },
        { value: 'mersekelten_novekvo', label: 'Mérsékelten növekvő érdeklődés (10-20%)' },
        { value: 'stabil', label: 'Stabil érdeklődés (+/- 10%)' },
        { value: 'csokkeno', label: 'Csökkenő érdeklődés (10-20%)' },
        { value: 'jelentosen_csokkeno', label: 'Jelentősen csökkenő érdeklődés (>20%)' },
        { value: 'ingadozo', label: 'Ingadozó' }
    ],
    en: [
        { value: 'jelentosen_novekvo', label: 'Significantly increasing interest (>20%)' },
        { value: 'mersekelten_novekvo', label: 'Moderately increasing interest (10-20%)' },
        { value: 'stabil', label: 'Stable interest (+/- 10%)' },
        { value: 'csokkeno', label: 'Decreasing interest (10-20%)' },
        { value: 'jelentosen_csokkeno', label: 'Significantly decreasing interest (>20%)' },
        { value: 'ingadozo', label: 'Fluctuating' }
    ]
};

export const PONTHATARAK_ALAKULASA_OPTIONS = {
    hu: [
        { value: 'emelkedo', label: 'Emelkedő (verseny növekszik)' },
        { value: 'stabil', label: 'Stabil' },
        { value: 'csokkeno', label: 'Csökkenő' },
        { value: 'ingadozo', label: 'Ingadozó' }
    ],
    en: [
        { value: 'emelkedo', label: 'Increasing (growing competition)' },
        { value: 'stabil', label: 'Stable' },
        { value: 'csokkeno', label: 'Declining' },
        { value: 'ingadozo', label: 'Fluctuating' }
    ]
};

export const MUNKAREND_TREND_OPTIONS = {
    hu: [
        { value: 'nappali_novekvo', label: 'Nappali dominál, növekvő' },
        { value: 'nappali_stabil', label: 'Nappali dominál, stabil' },
        { value: 'nappali_csokkeno', label: 'Nappali dominál, csökkenő' },
        { value: 'levelevo_nepszerusodik', label: 'Levelező népszerűsödik' },
        { value: 'tavoktat_nepszerusodik', label: 'Távoktatás népszerűsödik' },
        { value: 'kiegyenlitett', label: 'Kiegyenlített megoszlás' }
    ],
    en: [
        { value: 'nappali_novekvo', label: 'Full-time studies dominant and increasing' },
        { value: 'nappali_stabil', label: 'Full-time studies dominant and stable' },
        { value: 'nappali_csokkeno', label: 'Full-time studies dominant and decreasing' },
        { value: 'levelevo_nepszerusodik', label: 'Increasing popularity of part-time studies' },
        { value: 'tavoktat_nepszerusodik', label: 'Increasing popularity of distance learning' },
        { value: 'kiegyenlitett', label: 'Balanced distribution' }
    ]
};

export const FINANSZIROZAS_MEGOSZLAS_OPTIONS = {
    hu: [
        { value: 'allami_dominal', label: 'Döntően állami finanszírozott hallgatók (>60%)' },
        { value: 'kiegyensulyozott', label: 'Kiegyensúlyozott' },
        { value: 'onkoltseg_dominal', label: 'Döntően önköltséges hallgatók (>60%)' }
    ],
    en: [
        { value: 'allami_dominal', label: 'State-funded students dominant (>60%)' },
        { value: 'kiegyensulyozott', label: 'Balanced' },
        { value: 'onkoltseg_dominal', label: 'Self-funded students dominant (>60%)' }
    ]
};

export const FOLDRAJZI_VONZASKOR_OPTIONS = {
    hu: [
        { value: 'eros_regionalis', label: 'Erős regionális vonzerő' },
        { value: 'orszagos', label: 'Országos vonzerő' },
        { value: 'nemzetkozi', label: 'Nemzetközi vonzerő' },
        { value: 'foleg_helyi', label: 'Főleg helyi vonzerő' }
    ],
    en: [
        { value: 'eros_regionalis', label: 'Strong regional attraction' },
        { value: 'orszagos', label: 'National attraction' },
        { value: 'nemzetkozi', label: 'International attraction' },
        { value: 'foleg_helyi', label: 'Predominantly local attraction' }
    ]
};

export const DIPLOMAS_FOGLALKOZTATAS_OPTIONS = {
    hu: [
        { value: 'kivalo', label: 'Kiváló (>95%)' },
        { value: 'jo', label: 'Jó (90-95%)' },
        { value: 'kozepes', label: 'Közepes (85-90%)' },
        { value: 'gyenge', label: 'Gyenge (<85%)' }
    ],
    en: [
        { value: 'kivalo', label: 'Excellent (>95%)' },
        { value: 'jo', label: 'Good (90-95%)' },
        { value: 'kozepes', label: 'Average (85-90%)' },
        { value: 'gyenge', label: 'Weak (<85%)' }
    ]
};

export const VEGZETTSEG_SZERINTI_ARANY_OPTIONS = {
    hu: [
        { value: 'magas', label: 'Magas (>80% szakmában dolgozik)' },
        { value: 'kozepes', label: 'Közepes (60-80%)' },
        { value: 'alacsony', label: 'Alacsony (<60%)' }
    ],
    en: [
        { value: 'magas', label: 'High (>80% employed in a field related to their qualification)' },
        { value: 'kozepes', label: 'Moderate (60–80%)' },
        { value: 'alacsony', label: 'Low (<60%)' }
    ]
};

export const JOVEDELMI_SZINT_OPTIONS = {
    hu: [
        { value: 'atlag_felett', label: 'Átlag felett (országos átlaghoz képest)' },
        { value: 'atlagos', label: 'Átlagos' },
        { value: 'atlag_alatt', label: 'Átlag alatt' }
    ],
    en: [
        { value: 'atlag_felett', label: 'Above average (compared to the national average)' },
        { value: 'atlagos', label: 'Average' },
        { value: 'atlag_alatt', label: 'Below average' }
    ]
};
